import httpService from "..";

export const getFuneralProductApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/product/${id}`,
    "get"
  );
};

export const getCompanyFuneralProductsApi = async (groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/product/group/${groupId}`,
    "get"
  );
};

export const addFuneralProductApi = async (data: {}, groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/product?groupId=${groupId}`,
    "post",
    data
  );
};

export const editFuneralProductApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/funeral/product/${id}`,
    "patch",
    data
  );
};